import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/intercom.vue
var o = {
	name: "DtIconIntercom",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--intercom"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Intercom",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "M19.317 13.005c0 .179-.07.35-.195.476a.662.662 0 0 1-.94 0 .676.676 0 0 1-.195-.476V7c0-.178.07-.35.195-.475a.662.662 0 0 1 .94 0 .676.676 0 0 1 .195.475v6.005Zm-.23 4.162c-.089.088-2.563 2.172-7.098 2.172s-6.993-2.072-7.097-2.161a.66.66 0 0 1-.202-.708.663.663 0 0 1 1.059-.298c.039.028 2.249 1.84 6.234 1.84 3.986 0 6.213-1.823 6.235-1.84a.672.672 0 0 1 .94.072.666.666 0 0 1-.066.928l-.006-.005ZM4.654 7a.68.68 0 0 1 .222-.466.662.662 0 0 1 .917.025.676.676 0 0 1 .192.441v5.994c0 .179-.07.35-.195.476a.662.662 0 0 1-.94 0 .676.676 0 0 1-.196-.476V7Zm3.337-1.333a.68.68 0 0 1 .222-.466.662.662 0 0 1 .917.025.676.676 0 0 1 .192.44v8.89c0 .178-.07.349-.195.475a.662.662 0 0 1-.94 0 .676.676 0 0 1-.196-.476V5.668Zm3.354-.334c0-.178.07-.349.195-.475a.662.662 0 0 1 .94 0 .676.676 0 0 1 .195.475V15c0 .178-.07.35-.195.475a.662.662 0 0 1-.94 0 .676.676 0 0 1-.195-.475V5.333Zm3.298.334c0-.179.07-.35.195-.476a.661.661 0 0 1 .94 0 .676.676 0 0 1 .196.476v8.889c0 .178-.07.349-.195.475a.662.662 0 0 1-1.136-.476V5.668ZM19.5 2h-15a2.462 2.462 0 0 0-1.763.726A2.512 2.512 0 0 0 2 4.5v15a2.534 2.534 0 0 0 .738 1.774A2.483 2.483 0 0 0 4.5 22h15a2.461 2.461 0 0 0 1.762-.724 2.512 2.512 0 0 0 .739-1.77V4.5a2.532 2.532 0 0 0-.736-1.772A2.482 2.482 0 0 0 19.504 2",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=intercom.js.map